import { render, staticRenderFns } from "./PersonalLots.vue?vue&type=template&id=3703f97f&"
import script from "./PersonalLots.vue?vue&type=script&lang=js&"
export * from "./PersonalLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports